<script setup lang="ts">
import { useUiStore } from '@/store/uiStore';

const uiStore = useUiStore();

const lastConfirm = computed(() => {
  if (!uiStore.confirmations) {
    return;
  }

  return uiStore.confirmations.at(-1);
});
</script>

<template>
  <div class="confirmation-layer">
    <transition name="fade">
      <div v-if="lastConfirm" class="confirmation-background">
        <UiConfirm
          :title="lastConfirm.title"
          :subtitle="lastConfirm.subtitle"
          :description="lastConfirm.description"
          :kind="lastConfirm.kind"
          :yes-text="lastConfirm.yesText"
          :no-text="lastConfirm.noText"
          :resolve="lastConfirm.resolve"
          :required-answer="lastConfirm.requiredAnswer"
          :choices="lastConfirm.choices"
        />
      </div>
    </transition>
  </div>
</template>

<style scoped lang="scss">
.confirmation-background {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(50, 50, 50, 0.8);
  // above every other overlay, incl. UiSelect's options panel (999)
  z-index: 1000;
  justify-content: center;
  align-items: center;
}
</style>
